import React, { useLayoutEffect, useReducer } from 'react';
import DemoForm from '../../Molecules/DemoForm/DemoForm';
import StepsSection from '../../Molecules/StepsSection/StepsSection';
import ContactForms from '../Controllers/ContactForms';
import Banners from './Banners';
import ChargingSolutionsTabs from './ChargingSolutionsTabs/ChargingSolutionsTabs';
import CMS from './CMS';
import EVValueSection from './EVValueSection';
import FAQ from './Faq';
import FourSteps from './FourSteps';
import MobileApp from './MobileApp';

function RealEstate() {
    useLayoutEffect(() => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }, []);
      const [overlayActive, toggleOverlay] = useReducer((s) => !s, false);
  return (
    <>
        <Banners />
        <EVValueSection />
        <FourSteps />
        <ChargingSolutionsTabs />
        <CMS toggleOverlay={toggleOverlay}/>
        <MobileApp />
        <StepsSection />
        <FAQ />
        <ContactForms className="true"/> 
        {overlayActive && (
        <div className="fixed !m-0 inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 ">
          <div className="bg-white rounded-2xl p-8 max-w-6xl w-full shadow-xl relative">
            <button
              onClick={toggleOverlay}
              className="absolute top-2 right-4 text-2xl font-bold text-gray-700"
            >
              &times;
            </button>
            <h2 className="text-xl font-bold mb-4">Schedule Demo</h2>
            <div className='h-[95%]'>
              <DemoForm toggleOverlay={toggleOverlay}/>
            </div>
          </div>
        </div>
         )}
    </>
  )
}

export default RealEstate